/* Adday ambassador application (sections/adday-ambassador-form.liquid).
   - Checks Email and both checkboxes on the page and lists any errors above the button.
     While there are errors the submit is stopped here, before Shopify's own form script
     (its hCaptcha spam check listens on the document and posts the form itself).
   - A valid form is left to Shopify: it runs the spam check and posts the form, then
     returns to this page, where the thank you message renders in place of the form.
     This script then moves focus to the message. */
(function () {
  'use strict';

  var EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function init(form) {
    if (form.hasAttribute('data-adday-amb-ready')) return;
    form.setAttribute('data-adday-amb-ready', '');

    var success = form.querySelector('[data-adday-amb-success]');
    var errorsBox = form.querySelector('[data-adday-amb-errors]');
    var email = form.querySelector('[data-adday-amb-email]');
    var checks = Array.prototype.slice.call(form.querySelectorAll('[data-adday-amb-check]'));
    if (!success || !errorsBox || !email) return;

    var checked = false;

    // The page checks the fields itself, so the browser's own bubbles stay off.
    form.noValidate = true;

    // Back on the page after Shopify posted the form: take the customer to the result.
    // Runs just after the page load, so the #form anchor jump does not undo it.
    function showResult() {
      if (!success.hidden) {
        success.focus({ preventScroll: true });
        success.scrollIntoView({ block: 'center' });
      } else if (!errorsBox.hidden) {
        errorsBox.scrollIntoView({ block: 'center' });
      }
    }
    if (!success.hidden || !errorsBox.hidden) {
      var later = function () { window.setTimeout(showResult, 250); };
      if (document.readyState === 'complete') {
        later();
      } else {
        window.addEventListener('load', later, { once: true });
      }
    }

    function problems() {
      var list = [];
      var value = email.value.trim();
      email.value = value;
      if (value === '') {
        list.push({ el: email, message: email.getAttribute('data-error-required') });
      } else if (!email.checkValidity() || !EMAIL_PATTERN.test(value)) {
        list.push({ el: email, message: email.getAttribute('data-error-invalid') });
      }
      checks.forEach(function (box) {
        if (!box.checked) list.push({ el: box, message: box.getAttribute('data-error-required') });
      });
      return list;
    }

    function showErrors(messages) {
      errorsBox.textContent = '';
      if (!messages.length) {
        errorsBox.hidden = true;
        return;
      }
      var ul = document.createElement('ul');
      messages.forEach(function (message) {
        var li = document.createElement('li');
        li.textContent = message;
        ul.appendChild(li);
      });
      errorsBox.appendChild(ul);
      errorsBox.hidden = false;
    }

    function mark(list) {
      [email].concat(checks).forEach(function (el) {
        el.removeAttribute('aria-invalid');
        el.removeAttribute('aria-describedby');
        if (el.type === 'checkbox' && el.closest('label')) el.closest('label').removeAttribute('data-invalid');
      });
      list.forEach(function (item) {
        item.el.setAttribute('aria-invalid', 'true');
        item.el.setAttribute('aria-describedby', errorsBox.id);
        if (item.el.type === 'checkbox' && item.el.closest('label')) item.el.closest('label').setAttribute('data-invalid', '');
      });
    }

    function update() {
      var list = problems();
      mark(list);
      showErrors(list.map(function (item) { return item.message; }));
      return list;
    }

    // Once errors have shown, update them as the customer fixes each one.
    function recheck() {
      if (checked) update();
    }
    email.addEventListener('input', function () { if (email.getAttribute('aria-invalid')) recheck(); });
    email.addEventListener('blur', recheck);
    checks.forEach(function (box) { box.addEventListener('change', recheck); });

    form.addEventListener('submit', function (event) {
      checked = true;
      var list = update();
      if (!list.length) return;
      // Stop here: Shopify's document listener would otherwise still post the form.
      event.preventDefault();
      event.stopPropagation();
      list[0].el.focus();
    });
  }

  function initAll(root) {
    Array.prototype.forEach.call((root || document).querySelectorAll('form.adday-pt-form__form'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', function (event) { initAll(event.target); });
})();
